interface ClienteProps {
  id: string
  razaoSocial: string
  nomeFantasia: string | null
  contatoNome: string | null
  contatoEmail: string | null
  localidade: string | null
}

export class Cliente {
  constructor(private readonly props: ClienteProps) {}

  get id() {
    return this.props.id
  }

  get razaoSocial() {
    return this.props.razaoSocial
  }

  get nomeFantasia() {
    return this.props.nomeFantasia
  }

  get contatoNome() {
    return this.props.contatoNome
  }

  get contatoEmail() {
    return this.props.contatoEmail
  }

  get localidade() {
    return this.props.localidade
  }
}
